export const formatCurrency = (value) => {
  if (value === null || value === undefined || isNaN(value)) return '0';
  return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
};

export const parseFormattedNumber = (str) => {
  if (!str) return 0;
  return parseFloat(str.toString().replace(/\s+/g, '')) || 0;
};
